module.exports = __webpack_public_path__ + "img/top-logo-2@2x.9b3a0c69.png";